import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PanelKey_Findings, PanelKey_Home } from '../../../_shared.js';
import './AdvisorMiniPanel_Findings.scss';
import { ICONS } from '@app/styles';
import { ModuleFE_Spotlight } from '../../../modules/ModuleFE_Spotlight/index.js';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { AdvisorMiniPanel } from '../AdvisorMiniPanel/AdvisorMiniPanel.js';
import { ModuleFE_AdvisorMini } from '../../../modules/ModuleFE_AdvisorMini.js';
import { Component_Findings } from '../../components/findings/Component_Findings/Component_Findings.js';
export class AdvisorMiniPanel_Findings extends AdvisorMiniPanel {
    static defaultProps = {
        panelKey: PanelKey_Findings,
        panelType: 'secondary',
    };
    //######################### Life Cycle #########################
    __onPathwayEndUpdated() {
        if (!ModuleFE_EMInterface.isPostDisposition())
            return;
        this.forceUpdate();
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state); // call super derive to resolve readonly mode into the state
        return state;
    }
    //######################### Logic #########################
    onPanelClick = () => ModuleFE_AdvisorMini.openPanel(this.props.panelKey);
    //######################### Render - Header #########################
    renderHeader_Title = () => 'Findings';
    renderHeader_Tail = () => {
        if (ModuleFE_EMInterface.isReadonly())
            return;
        const postDisposition = ModuleFE_EMInterface.isPostDisposition();
        return _jsxs(_Fragment, { children: [!postDisposition &&
                    _jsx(ICONS.advisor_avn_add.component, { onClick: () => ModuleFE_Spotlight.openEditFindings({ findings: { processedRawFindings: [], findingsToUpdate: [] } }) }), _jsx(ICONS.advisor_avn_close.component, { onClick: () => ModuleFE_AdvisorMini.openPanel(PanelKey_Home) })] });
    };
    //######################### Render - Content #########################
    _renderContent(scrollRef) {
        return _jsx(Component_Findings, { scrollRef: scrollRef });
    }
    renderContent = () => _jsx(_Fragment, {});
    //######################### Render - Rest #########################
    renderFooter = undefined;
    renderSubHeader = undefined;
}
//# sourceMappingURL=AdvisorMiniPanel_Findings.js.map